export default __webpack_public_path__ + "static/media/gnd_kr_head_a1.afba4ad4.mp3";